module.exports = __webpack_public_path__ + "img/wink-ok.2b614927.png";